/** Shared "download this media file, never a new tab, never opened inline"
 * helper (VISTOERA_CONTENT_CANVAS_MEDIA_CARD_AND_GENERATION_INTERACTION_V2
 * §12/§16/§20/§30 — every media card's header hover `[下载]`).
 *
 * VISTOERA_CONTENT_CANVAS_PREVIEW_E2E_DOWNLOAD_CORS_FIX (2026-09-03) — the
 * previous implementation `fetch()`ed the bytes itself (`credentials:
 * 'include'`) and downloaded from a same-origin `blob:` URL. That works on
 * Local (frontend and backend on the same origin) but is BROKEN on Preview,
 * where the frontend (`app-preview.vistoera.com`) and backend
 * (`api-preview.vistoera.com`) are different origins AND the backend's
 * `TENANT_PRIVATE_IMMUTABLE`/`_LARGE` asset routes 302-redirect to a
 * short-lived presigned R2 GET (`asset_delivery.py`'s `presigned` mode) —
 * a cross-origin `fetch()` follows that redirect but then fails the CORS
 * check on R2's own response (`TypeError: Failed to fetch`), even though
 * the exact same URL loads fine as a plain `<img src>` (images are never
 * subject to CORS). Confirmed live against Preview during this task's own
 * Browser E2E (TEST 16).
 *
 * The fix already exists elsewhere in this codebase (`AIChatPage.tsx`'s
 * `triggerDownload`/`forcedDownloadUrl`, `../../../api/client.ts`'s
 * `triggerBrowserDownload`): append `?download=true` to the SAME
 * inline-preview content URL so the backend answers with
 * `Content-Disposition: attachment` (see `saas_assets.py::get_variant`,
 * `saas_image_generation.py::get_output_content`) — a plain `<a href>`
 * click (no `target="_blank"`) against a response carrying that header
 * always triggers a native "Save As" regardless of origin, because that's
 * a browser navigation, never a JS-mediated cross-origin *read* — CORS
 * simply does not apply. The real filename comes from that same header,
 * never invented client-side. Zero backend byte-proxying detour needed;
 * R2 keeps serving the bytes directly. */

function withDownloadParam(url: string): string {
  return `${url}${url.includes('?') ? '&' : '?'}download=true`
}

export function downloadCanvasMedia(url: string): void {
  const a = document.createElement('a')
  a.href = withDownloadParam(url)
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
}
